import React from 'react'
import Footer from '../../components/Footer/Footer'
import Navbar1 from '../../components/Navbar1/Navbar1'
import Aboutus from './Aboutus'



const About = () => {
  return (
    <div>
        <Navbar1 />
        <Aboutus />
        <Footer />
    </div>
  )
}

export default About